/* eslint-disable @typescript-eslint/no-use-before-define */
import { h } from "@stencil/core";
import { SuggestItemData } from "@genexus/chameleon-controls-library/dist/types/deprecated-components/suggest/suggest-list-item/ch-suggest-list-item";
import { SuggestListData } from "@genexus/chameleon-controls-library/dist/types/deprecated-components/suggest/suggest-list/ch-suggest-list";
import { SuggestData } from "@genexus/chameleon-controls-library/dist/types/deprecated-components/suggest/ch-suggest";

export const renderSuggestLists = (
  suggestData: SuggestData
): HTMLChSuggestListElement[] => {
  if (suggestData?.suggestLists.length) {
    return suggestData.suggestLists.map(
      (list: SuggestListData): HTMLChSuggestListElement => {
        return (
          <ch-suggest-list label={list.label}>
            {list.items.map((item: SuggestItemData) => {
              return renderSuggestListsItem(item);
            })}
          </ch-suggest-list>
        );
      }
    );
  }
  return [];
};

const renderSuggestListsItem = (
  suggestItem: SuggestItemData
): HTMLChSuggestListItemElement => {
  return (
    <ch-suggest-list-item value={suggestItem.value}>
      {[
        suggestItem.description || suggestItem.value,
        suggestItem.icon && renderIcon(suggestItem.icon)
      ]}
    </ch-suggest-list-item>
  );
};

const renderIcon = (iconName: string): HTMLGxgIconElement => {
  return <gxg-icon color="auto" type={iconName} slot="icon"></gxg-icon>;
};
